import React from 'react';
import FeedSwitch from '../FeedSwitch';
import SuggestedMembersRiver from '../SuggestedMembersRiver';
import { FEED_ITEM, FOLLOW_SUGGESTION } from '../../constants';

const CommunitySectionSwitch = props => {
  switch (props.section_type) {
    case FEED_ITEM:
      return <FeedSwitch {...props} />;
    case FOLLOW_SUGGESTION:
      return <SuggestedMembersRiver />;
    default:
      // TODO: Printing out the name here in development to see what we still need to implement
      return <div>{props.section_type}</div>;
  }
};

export default CommunitySectionSwitch;
